import { render, staticRenderFns } from "./operacoes-estudante.vue?vue&type=template&id=c535366c&"
import script from "./operacoes-estudante.vue?vue&type=script&lang=js&"
export * from "./operacoes-estudante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports